import React, { useEffect, useRef, useState, memo } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { parseDate } from '../../utilities/helpers';
import { t } from '../../utilities/translator';
import format from '../../utilities/format';
import { getDisplayPrice } from '../../utilities/priceHelper';
import { WithTooltip } from '../../components/tooltip/WithTooltip';
import { selectDepartures, selectDestinations } from '../mainFilter/selectors';
import CardTitle from './DealItemExperimental/CardTitle';
import DealSlider from './DealItem/DealSlider';
import useBodyScrollLock from '../../hooks/useBodyScrollLock';
import DealOfTheDayModal from './DealOfTheDayModal';
import useDealClickHandler from '../../hooks/dealItem/useDealClickHandler';
// import abTesting from '../../services/abTesting';
import { pushEvent } from '../../utilities/analytics';
import {
  DOTD_CARD_CLICK,
  DOTD_POPUP_CLOSE,
} from '../../constants/analyticEvents';


const DealOfTheDay = ({
  dealItem,
  position,
  bestOutOfDestination,
  hideSettings,
}) => {
  const cardRef = useRef(null);
  const destinations = useSelector(selectDestinations);
  // const departures = useSelector(selectDepartures);
  const [cardHeight, setCardHeight] = useState(518);
  // const [isSettingsShown, setIsSettingsShown] = useState(false);
  const [cardTitle, setCardTitle] = useState('');
  const [sliderTutorialShown, setSliderTutorialShown] = useState(false);
  const [hideDealOfTheDay, setHideOfTheDay] = useState(!!sessionStorage.getItem('hideDealOfTheDay'));
  const [showOfferPopup, setShowOfferPopup] = useState(false);
  const [subscribeSuccess, setSubscribeSuccess] = useState(false);
  const [dotdShow, setDotdShow] = useState(false);
  const { destinationData, offer, hotel } = dealItem;
  const { name } = destinationData;
  const { outboundDate, inboundDate, hfOfferId } = offer;
  const { photos } = hotel;
  const depDate = parseDate(outboundDate);
  // const arrDate = parseDate(inboundDate);
  // const stayDatesText = `${format(depDate, 'E d MMM')} - ${format(arrDate, 'E d MMM')}`;
  const dealDestination = destinations && destinations.find(destination => destination?.id === dealItem?.destinationData?.destinationId);
  // const dealDeparture = departures && departures.filter(dep => dep.id === flight.city_from_airport_code);

  const userContext = JSON.parse(localStorage.getItem('hf_user'));
  const isUserLoggedIn = (userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth);
  const isSubscribed = !!(userContext && userContext?.userNotificationPreferences?.enabledDealOfTheDay);
  const [userLoggedIn, setUserLoggedIn] = useState(isUserLoggedIn);
  const [userLoggedIn2, setUserLoggedIn2] = useState(isUserLoggedIn);

  const [isSubscribed2, setIsSubscribed2] = useState(isSubscribed);

  // console.log('AAADEALOFTHEDAY:', userContext, userLoggedIn, isUserLoggedIn, isSubscribed);

  useBodyScrollLock({ condition: showOfferPopup, mobileOnly: false });

  useEffect(() => {
    setDotdShow(true);
    let timeout = null;
    let timeout2 = null;
    if (cardRef.current) {
      setCardHeight(cardRef.current.clientHeight > 0 ? cardRef.current.clientHeight : 518);
      timeout = setTimeout(() => {
        if (document.querySelector('.deal-item-bswrap[data-position="3"] .flip-card-inner') && document.querySelector('.deal-item-bswrap[data-position="3"] .flip-card-inner').offsetHeight) {
          setCardHeight(document.querySelector('.deal-item-bswrap[data-position="3"] .flip-card-inner').offsetHeight);
        }
      }, 500);
    }

    const onLoginSuccess = (e) => {
      if (e && e?.detail?.name === 'loginModal.success') {
        // console.log('DOTD-LOGIN-SUCCESS:', e?.detail);
        setUserLoggedIn(true);
        timeout2 = setTimeout(() => {
          setUserLoggedIn2(true);
        }, 300);
      }
      if (e && e?.detail?.name === 'userContextSet') {
        setIsSubscribed2(!isSubscribed2);
      }
    };
    document.addEventListener('travelyo:user', onLoginSuccess);
    return () => {
      document.removeEventListener('travelyo:user', onLoginSuccess);
      clearTimeout(timeout);
      clearTimeout(timeout2);
    };
  }, []);

  const handleDealClick = useDealClickHandler(dealItem, position, '', sliderTutorialShown, true);

  const handleDOTDClick = (e) => {
    const elClasses = e?.target.classList;
    const ignoreElementClasses = [
      'ri-arrow-left-s-line',
      'ri-arrow-right-s-line',
      'dotd-hide',
      'dotd-tt',
      'ri-information-line',
      'ri-eye-off-line',
    ];
    const elementsToOpenModal = [
      'dotd-not-subscribed',
      'dotd-ns-title',
      'dotd-ns-txt',
      'dotd-ns-butons',
      'dotd-subscribe',
    ];

    if (ignoreElementClasses.some((item) => elClasses?.contains(item))) {
      return undefined;
    }

    const userContext = JSON.parse(localStorage.getItem('hf_user'));
    const isUserLoggedIn = (userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth);

    if (!isUserLoggedIn && typeof openLoginModal === 'function') {
      // eslint-disable-next-line no-undef
      openLoginModal("Deal of the day", "dealOfTheDay");
      pushEvent(DOTD_CARD_CLICK, { isLogin: false, offer: dealItem, type: 'open-login', isSubscribed: isSubscribed });
    }

    if (isUserLoggedIn) {
      if (elementsToOpenModal.some((item) => elClasses?.contains(item))) {
        // if user clicked dotd-not-subscribed block -> show modal
        setShowOfferPopup(true);
        window.history.pushState(
          { type: 'dealOfTheDay' },
          null,
          window.location.href
        );
        if (document.getElementsByClassName('css-1ctqydd')[0]) {
          document.getElementsByClassName('css-1ctqydd')[0].classList.add('zind0');
        }
        pushEvent(DOTD_CARD_CLICK, { isLogin: true, offer: dealItem, type: 'open-popup', isSubscribed: isSubscribed });
      } else {
        // open offer page
        pushEvent(DOTD_CARD_CLICK, { isLogin: true, offer: dealItem, type: 'open-offer', isSubscribed: isSubscribed });
        handleDealClick();
      }
    }
  };

  const closeOfferModal = () => {
    setShowOfferPopup(false);
    setSubscribeSuccess(false);
    if (document.getElementsByClassName('css-1ctqydd')[0]) {
      document.getElementsByClassName('css-1ctqydd')[0].classList.remove('zind0');
    }
    if (window.history.state && window.history.state.type === 'dealOfTheDay') {
      window.history.back();
    }
    pushEvent(DOTD_POPUP_CLOSE, { offer: dealItem, subscribeClicked: subscribeSuccess });
  };

  const getCapacity = () => {
    const {
      capacity: {
        adult,
        child
      },
      capacity_from_filter,
    } = offer;
    let kids = child;
    const babies =
      capacity_from_filter.childAges.filter((kid) => kid < 2).length || 0;
    kids = kids - babies;

    return { adult, kids, babies };
  };

  const getOfferPrice = () => {
    const {
      price,
    } = offer;
    const { adult, kids } = getCapacity();

    return getDisplayPrice(Math.ceil(price / (adult + kids)));
  };

  const getHotelRating = () => {
    return Array.from({ length: hotel.rating }, (_, index) => (
      <i key={index} className="ri-star-fill" />
    ));
  };

  const openLogin = () => {
    // console.log('Open login modal');
    if (typeof openLoginModal === 'function') {
      // eslint-disable-next-line no-undef
      openLoginModal("Deal of the day", "dealOfTheDay");
    }
    pushEvent(DOTD_CARD_CLICK, { isLogin: false, offer: dealItem });
  };

  const clickHideDealOfTheDay = () => {
    sessionStorage.setItem('hideDealOfTheDay', 1);
    setHideOfTheDay(true);
  };

  if (hideDealOfTheDay) {
    return null;
  }

  return (
    <div
      className={classNames("deal-item-experimental deal-otd-item pb-10 col-lg-3 col-md-4 col-sm-6 deal-item-bswrap relative", { 'deal-otd-show': dotdShow })}
      data-position={position + 1}
      data-hfofferid={hfOfferId}
      data-isdotd={true}
      data-isloggedin={userLoggedIn}
      data-isdotdsubscribed={isSubscribed}
    >
      {!hideSettings && (
        <CardTitle
          onClick={() => false}
          setCardTitle={setCardTitle}
          hotel={hotel}
          dealDestination={dealDestination}
          destinations={destinations}
          bestOutOfDestination={bestOutOfDestination}
          noClick={true}
        />
      )}
      <div className={classNames("deal-otd-main shadow-lg", { 'dotd-subscribed': isSubscribed, 'dotd-not-auth': !userLoggedIn })} style={{ height: cardHeight }} ref={cardRef} onClick={handleDOTDClick}>
        <div className={classNames("dotd-top", { 'dotdt-ns': !isSubscribed })}>
          <div className="dotd-head flex">
            <div className="dotd-h1 flex">
              <i className="ri-trophy-line" />
              <span>{t('dealOfTheDay.todaysDealOfTheDay')}</span>
            </div>
            <span className="dotd-hide" onClick={clickHideDealOfTheDay} title={t('dealOfTheDay.hideDealOfTheDay')}><i className="ri-eye-off-line" /></span>
          </div>
          <div className="gallery relative">
            <div className="slider overflow-hidden">
              <LazyLoadComponent threshold={200}>
                <DealSlider
                  photos={photos}
                  index={position}
                  dealItem={dealItem}
                  setTutorialVisible={setSliderTutorialShown}
                />
              </LazyLoadComponent>
            </div>
          </div>
          <div className="dotd-info">
            <div className="deal-destination-name">{name}</div>
            <div className="deal-rating flex text-xs">
              {getHotelRating()}
            </div>
            <div className="hotel-name leading-5 label-large md:whitespace-nowrap text-ellipsis overflow-hidden text-start">{hotel.name}</div>
            <div className="dotd-info-bottom flex justify-between pt-3 items-center">
              <div className="leading-4 !font-medium">
                {offer.duration} {t("dealItem.nights_plural", { count: offer.duration })} · {format(depDate, 'd MMM')}
              </div>
              <div className="flex flex-col gap-1 items-end js-offer-price">
                <span className="text-xl font-semibold leading-none">{getOfferPrice()}</span>
                <span className="text-[10px] !font-medium leading-none">{t('dealItem.per_person')}</span>
              </div>
            </div>
          </div>
        </div>
        {!isSubscribed &&
          <div className="dotd-not-subscribed flex flex-col gap-2">
            <div className="dotd-ns-top" />
            <div className="dotd-ns-title leading-4 !font-semibold">{t('dealOfTheDay.notTheRightFit')}</div>
            <div className="dotd-ns-txt">
              {t('dealOfTheDay.receiveNewDeal')}
            </div>
            <div className="dotd-ns-butons flex justify-between items-center pt-3">
              <button className="dotd-subscribe cursor-pointer">{t('dealOfTheDay.getDailyUpdates')}</button>
              <WithTooltip text={`<div class="price-tooltip"><b>${t('dealOfTheDay.tooltipTitle')}</b><span>${t('dealOfTheDay.tooltipTxt')}</span></div>`}>
                <span className="dotd-tt"><i className="ri-information-line" /></span>
              </WithTooltip>
            </div>
          </div>
        }
      </div>

      {!userLoggedIn2 &&
        <div className={classNames("dotd-no-login", { 'dotd-nl-hide': userLoggedIn })}>
          <div className="dotd-nl-main">
            <div className="dotd-nl-icon" />
            <div className="dotd-nl-txt">
              <b>{t('dealOfTheDay.dealOfTheDay')}</b>
              <div>
                {t('dealOfTheDay.discoverIncrediblePackages')}
              </div>
            </div>
            <div className="dotdt-nl-button flex justify-center">
              <button className="cursor-pointer move-btn move-btn--primary move-btn--large rounded" onClick={openLogin}>{t('dealOfTheDay.reveal')}</button>
            </div>
          </div>
        </div>
      }

      {userLoggedIn &&
        <DealOfTheDayModal
          dealItem={dealItem}
          showOfferPopup={showOfferPopup}
          closeModal={closeOfferModal}
          offerPrice={getOfferPrice()}
          position={position}
          sliderTutorialShown={sliderTutorialShown}
          subscribeSuccess={subscribeSuccess}
          setSubscribeSuccess={setSubscribeSuccess}
        />
      }
    </div>
  )
};

export default memo(DealOfTheDay);
